import React from 'react';
import { Card as MuiCard } from '@mui/material';
import { motion } from 'framer-motion';
import { styled } from '@mui/material/styles';

/**
 * Hover Card Component with scale and shadow effects
 */
const StyledHoverCard = styled(motion(MuiCard))(({ theme }) => ({
  borderRadius: theme.custom.borderRadius.lg,
  boxShadow: theme.custom.boxShadow.md,
  transition: 'all 0.3s ease-in-out',
  cursor: 'pointer',
  overflow: 'hidden',
  
  '&:hover': {
    boxShadow: theme.custom.boxShadow.xl,
  },
}));

const HoverCard = ({ 
  children,
  onClick,
  hoverScale = 1.03,
  ...props 
}) => {
  const motionProps = {
    whileHover: { scale: hoverScale, y: -4 },
    whileTap: { scale: 0.98 },
    transition: { duration: 0.3 },
  };

  return (
    <StyledHoverCard {...motionProps} onClick={onClick} {...props}>
      {children}
    </StyledHoverCard>
  );
};

export default HoverCard;
